export function calculateTimeSinceDeployment(scanDate, approvalDate) {
  const sd = new Date(scanDate);
  const ad = new Date(approvalDate);
  if (isNaN(sd) || isNaN(ad)) return null;
  return Math.floor((ad.getTime() - sd.getTime()) / 86400000);
}

export function filterLifecyclePoints(points, { series = 'all', startDate = '', endDate = '' } = {}) {
  return (Array.isArray(points) ? points : [])
    .filter(p => (series === 'all' || p.series === series))
    .filter(p => (!startDate || p.approvalDate >= new Date(startDate)))
    .filter(p => (!endDate || p.approvalDate <= new Date(endDate)));
}
